import React,{ useState, useEffect } from 'react';
import { Carousel } from 'react-bootstrap';
import Spinner from 'react-bootstrap/Spinner';

export const CurrentHorseSlideshow = (props) => {
    const [data, setdata] = useState([]);
  const [loaded, setloaded] = useState(false);

  useEffect(() => {
    if(props.data.length !== 0) {
      setdata(props.data);
      setloaded(true);
    }
  }, [props]);

  function info() {
    return(
      <Carousel key={data.current.hipnr}>
        {data.current.images.map(img => (
          <Carousel.Item key={img}>
            <div style={{
              width: "100%",
              height: "100%",
              backgroundImage: `url(${img})`,
              backgroundPosition: "50%",
              backgroundSize: "100%"
            }}></div>
          </Carousel.Item>
       ))}
      </Carousel>
    )
  }

  let content = loaded
  ? info()
  : <></>;

  return(
    <>
      {content}
    </>
  );
}